{
  "addSensor": "Agregar sensor",
  "linearMovePathTitle": "Ruta de movimiento lineal",
  "centerPivotPathTitle": "Esquema del pivote central",
  "addSensorAlreadyAddedWithSensorNameErrorMessage": "Este dispositivo ya tiene un sensor {{sensorName}} configurado. Comuníquese con el servicio de asistencia de FarmHQ si necesita ayuda.",
  "addSensorCannotAddToExistingErrorMessage": "Este sensor no se puede agregar a una configuración existente. Comuníquese con el servicio de asistencia de FarmHQ si necesita ayuda.",
  "addSensorInstructions": "Seleccione un sensor para agregarlo a la configuración de su dispositivo.",
  "addSensorNotCompatibleErrorMessage": "Este sensor no es compatible con la configuración del dispositivo. Comuníquese con el servicio de asistencia de FarmHQ si necesita ayuda.",
  "addSensorTitleWithSensorName": "Agregar configuración del sensor {{sensorName}}",
  "chooseInstallationType": "Elija el tipo de instalación",
  "choosePressureSensorModelInstructions": "Seleccione el modelo de sensor de presión que está instalado en su dispositivo.",
  "choosePumpTypeInstructions": "Elija la opción que mejor describa su equipo e instalación.",
  "choosePumpTypeTitle": "Seleccione el tipo de bomba",
  "choosePumpType_pump_off_only": {
    "description": "Bomba de solo apagado (Diesel, parada de emergencia eléctrica)",
    "label": "Bomba de solo apagado"
  },
  "choosePumpType_pump_on_off": {
    "description": "Contacto único de encendido y apagado (diésel, eléctrico, etapa 4)",
    "label": "Bomba de encendido y apagado"
  },
  "choosePumpType_pump_vfd": {
    "description": "Bomba VFD con control de velocidad",
    "label": "Bomba VFD"
  },
  "chooseSensorPortInstructionsWithSensorName": "Seleccione el puerto del sensor donde está instalado el sensor {{sensorName}}.\n\nTenga en cuenta que los puertos de sensor que no coincidan correctamente impedirán que su dispositivo produzca lecturas correctas. Si no está seguro, comuníquese con el servicio de asistencia de FarmHQ.",
  "chooseSensorPortStageTitle": "Seleccionar puerto del sensor",
  "clickSensorToManage": "Haga clic en un sensor para ver o administrar su configuración.",
  "clickSensorToManageMobile": "Toque un sensor para ver o administrar su configuración.",
  "configurationInfoTitle": "Información de configuración",
  "configurationRequiredMessage": "Antes de realizar esta acción, debe ingresar la información de configuración para este dispositivo.",
  "configurationRequiredTitle": "Configuración requerida",
  "configuredSensors": "Sensores configurados",
  "confirm": "Confirmar",
  "customizeDeviceNameInstructions": "Puedes darle un apodo a tu dispositivo para identificarlo. Este nombre se mostrará en la aplicación FarmHQ. Si dejas este campo en blanco, el dispositivo recibirá el nombre del alias de producto.",
  "customizeDeviceNameStageTitle": "Personalizar el nombre del dispositivo",
  "deleteSensor": "Eliminar sensor",
  "deleteSensorImpactFunctionalityWarning": "Esto puede tener efectos negativos en la funcionalidad de su dispositivo. \n\nSi no está seguro de lo que está haciendo, comuníquese con el servicio de asistencia de FarmHQ.",
  "deleteSensorSensorIsRequiredMessage": "Este sensor es necesario para que su dispositivo funcione y no se puede eliminar. Si necesita ayuda, comuníquese con FarmHQ.",
  "deleteSensorTitleWithSensorName": "Confirmar eliminación de la configuración de {{sensorName}}",
  "deviceInstallationType": "Tipo de instalación",
  "deviceName": "Nombre del dispositivo",
  "deviceNameInputLabel": "Nombre del dispositivo",
  "deviceNameInputPlaceholder": "Introduzca un nombre para este dispositivo",
  "deviceSetup": "Configuración del dispositivo",
  "doesItHaveAFlowSensor": "¿El dispositivo tiene un sensor de flujo instalado?",
  "doesItHaveAPressureSensor": "¿El dispositivo tiene un sensor de presión instalado?",
  "edit": "Editar",
  "editSensorField": "Editar campo de sensor",
  "forbidden": "Prohibido",
  "hardwareGeneration": "Generación de hardware",
  "helpContentBodyText": "Las configuraciones del dispositivo se utilizan para configurar el dispositivo con los sensores y ajustes correctos. Esto garantiza que el dispositivo pueda rastrear y generar informes de datos con precisión, y se pueda utilizar en automatizaciones y notificaciones.",
  "hintWithColon": "Pista:",
  "hose": "Manguera",
  "linkTo": "Configuración",
  "manageSensor": "Administrar sensor",
  "manageSensorWithSensorName": "Administrar el sensor {{sensorName}}",
  "newConfiguration": "Nueva configuración",
  "newDeviceConfiguration": "Nueva configuración del dispositivo",
  "newReelConfiguration": "Nueva configuración de carrete",
  "noConfiguredSensorsMessage": "No hay sensores configurados para este dispositivo.",
  "notNow": "Ahora no",
  "nozzle": "Boquilla",
  "pathConfigurationLinearTitle": "Configuración de ruta lineal",
  "pathConfigurationPivotTitle": "Configuración de pivote",
  "pc1PumpSetupStageTitle": "Configuración de la bomba PC1 (Legacy)",
  "pressureSensor": "Sensor de presión",
  "pressureSensorModelNameMeas": "MEDIDAS",
  "pressureSensorModelNameOther": "Otro",
  "pressureSensorModelNameSoway": "Soway",
  "pressureSensorModelNameTrafag": "Trafag",
  "pressureSensorModelStageTitle": "Elija el modelo del sensor de presión",
  "pressureThresholdsHelpText": "Los umbrales de presión ayudan a determinar cuándo un dispositivo con un centro de presión bombea más o menos agua de lo esperado.",
  "pressureThresholdsStageTitle": "Umbrales de presión",
  "pumpType": "Tipo de bomba:",
  "removeFromFarmAreYouSure": "¿Está seguro de que desea eliminar este dispositivo de esta cuenta de granja?",
  "removeFromFarmLinkTo": "Eliminar de la granja",
  "removeFromFarmTitle": "Confirmar eliminación del dispositivo",
  "removeFromFarmWarning": "El dispositivo se restablecerá a los valores de fábrica y ya no aparecerá en esta cuenta. Esto no se puede deshacer.",
  "rename": "Rebautizar",
  "renameDevice": "Cambiar el nombre del dispositivo",
  "renameThisDevice": "Cambiar el nombre de este dispositivo",
  "resetDeviceAreYouSure": "¿Está seguro de que desea restaurar este dispositivo a los valores predeterminados?",
  "resetDeviceLinkTo": "Restablecimiento de fábrica",
  "resetDeviceTitle": "Confirmar reinicio del dispositivo",
  "resetDeviceYouWillLoseConfigurations": "Perderá todas las configuraciones de sensores y cualquier otra personalización. Esta acción no se puede deshacer.",
  "resetDeviceYouWillLoseTriggers": "También se eliminarán todos los pares de dispositivos, notificaciones y automatizaciones.",
  "reviewAndSubmitInstructions": "Su dispositivo se configurará con los siguientes ajustes. Revíselos y envíelos para guardar los cambios.",
  "selectPressureSensorToContinue": "Seleccione un modelo de sensor de presión para continuar. Si no está seguro, comuníquese con el servicio de asistencia de FarmHQ.",
  "sensorPortHint": "Asegúrese de que el puerto del sensor esté identificado correctamente. Los puertos del sensor conmutados pueden generar lecturas incorrectas.",
  "sensors": "Sensores",
  "setPressureThresholdInstructions": "Establezca umbrales de presión para determinar cuándo su equipo está bombeando más o menos agua de lo esperado.",
  "setUp": "Configurar el dispositivo",
  "setUpCenterPivot": "Configuración de pivote central",
  "setUpDevice": "Configurar el dispositivo",
  "setUpLinearMove": "Configuración de movimiento lineal",
  "setUpPump": "Configuración de la bomba",
  "setUpReel": "Configuración del carrete",
  "setUpReelDescription": "Ingrese la información de calibración de su carrete para garantizar un seguimiento preciso del riego, ETA y otras métricas.",
  "setUpSoftHoseTraveler": "Configuración del viajero con manguera blanda",
  "setUpTravelerSoft": "Configuración del viajero con manguera blanda",
  "setUpValve": "Configuración de la válvula",
  "spool": "Carrete",
  "thisDeviceAlreadyHasThatSensorWithSensorName": "Este dispositivo ya tenía una configuración de {{sensorName}} activa. Para editarla o eliminarla, selecciónela de la lista.",
  "title": "Configuración",
  "unconfiguredDeviceWarning": "Este dispositivo no está configurado.",
  "updateConfigurationDataLossWarning": "El dispositivo también puede experimentar una pérdida temporal de datos mientras se sincronizan los cambios.",
  "updateConfigurationSwitchOnToOffWarning": "Al actualizar la configuración del dispositivo, el interruptor se apague si está encendido actualmente.",
  "vfdTrackingSpeedsStageTitle": "Velocidades de seguimiento de VFD",
  "wheelDiameterMmInstructions": "Mida el diámetro de la rueda e introdúzcalo aquí.",
  "wheelDiameterStageTitle": "Diámetro de la rueda",
  "wheelMagnetsStageTitle": "Imanes para ruedas",
  "wheelNMagnetsInstructions": "Introduzca el número de imanes instalados en la rueda.",
  "wheelSensorPortInstructions": "¿Dónde está instalado el sensor de rueda?",
  "wheelSensorPortStageTitle": "Puerto del sensor de rueda",
  "wheelStoppedTimeoutInstructions": "Cuánto tiempo debe esperar el dispositivo sin detectar movimiento de la rueda antes de informar que la rueda está detenida.",
  "wheelStoppedTimeoutStageTitle": "Tiempo de espera de rueda detenida",
  "wouldYouLikeToSetLinearPath": "¿Quieres establecer la ruta lineal ahora?"
}
